export const getFlags = state => state.featureFlags.flags;
export const getFlagValue = (state, flagName) => getFlags(state)[flagName];
export const areFlagsLoaded = state => state.featureFlags.loaded;



// WEBPACK FOOTER //
// ./src/selectors/featureFlags.js